module.exports = __webpack_public_path__ + "static/media/please.78872ebd.gif";